enum InvoiceBillingReason {
    MANUAL = 'manual',
    SUBSCRIPTION = 'subscription',
    SUBSCRIPTION_CREATE = 'subscription_create',
    SUBSCRIPTION_CYCLE = 'subscription_cycle',
    SUBSCRIPTION_THRESHOLD = 'subscription_threshold',
    SUBSCRIPTION_UPDATE = 'subscription_update',
    UPCOMING = 'upcoming',
}

export default InvoiceBillingReason;
